class CartCheckoutButton extends HTMLElement {
  constructor() {
    super();

    this.cart = null;
    this.minPrice = this.dataset.minPrice;
    this.button = this.querySelector('#cart-button');
    this.error = this.querySelector('#cart-button-error');
    this.hideClass = 'hide';

    document.addEventListener(
      'theme:cart:change',
      function (event) {
        this.cart = event.detail.cart;
        this.update();
      }.bind(this)
    );
  }

  update() {
    if (this.cart && this.cart.total_price >= this.minPrice) {
      if (!this.error?.classList.contains(this.hideClass)) {
        this.error?.classList.add(this.hideClass);
      }
      this.button.removeAttribute('disabled');
    } else {
      if (this.error?.classList.contains(this.hideClass)) {
        this.error?.classList.remove(this.hideClass);
      }
      this.button.setAttribute('disabled', true);
    }
  }
}

customElements.define('cart-checkout-button', CartCheckoutButton);
